/**
 * Shared FetchBlockOutputsV2 payload for classic and revamp builder tables.
 */

export function getBuilderBlockDimensionIdsString(plannerBlock: {
  dimensions?: { id: number; name: string }[];
}): string {
  if (!plannerBlock?.dimensions) return '';
  return plannerBlock.dimensions
    .filter((item) => item.name !== 'Time')
    .map((item) => item.id)
    .join(', ');
}

export type BuildFetchBlockOutputsV2PayloadOptions = {
  blockId: number | string | undefined;
  plannerBlock: { dimensions?: { id: number; name: string }[] } | null | undefined;
  scenarioId: number;
  useArrowResponse: boolean;
};

/**
 * Build the Redux thunk argument for block outputs v2 (JSON or Arrow multipart).
 */
export function buildFetchBlockOutputsV2Payload({
  blockId,
  plannerBlock,
  scenarioId,
  useArrowResponse,
}: BuildFetchBlockOutputsV2PayloadOptions) {
  return {
    blockId,
    params: {
      dim_id: getBuilderBlockDimensionIdsString(plannerBlock ?? {}),
      indicator_filter: 'all',
      scenario_id: scenarioId,
      time_aggregation: 'M',
    },
    useArrowResponse,
  };
}
